<template>
  <div>     
      <notifications group="notify" />
      <router-view></router-view>
  </div>
</template>

<script>
  
export default {
   
}
</script>
 
